import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Initial = () => {
  const navigate = useNavigate();

  return (
    <Container 
      maxWidth="md" 
      sx={{ 
        minHeight: "100vh", 
        display: "flex", 
        flexDirection: "column", 
        justifyContent: "center",
        textAlign: "center",
        py: 8
      }}
    >
      {/* Heading */}
      <Typography 
        variant="h3" 
        fontWeight="bold" 
        sx={{ mb: 3 }}
      >
        MyLandNest
      </Typography>

      {/* Paragraph */}
      <Typography 
        variant="h6" 
        color="text.secondary" 
        sx={{ mb: 4 }}
      >
        Welcome to MyLandNest — your trusted platform for buying, selling, 
        renting, and leasing properties. Whether you're searching for your 
        dream home, a commercial space, or investment opportunities, 
        MyLandNest connects you with the best real estate options 
        tailored to your needs.
      </Typography>

      {/* Login Button */}
      <Button 
        variant="contained" 
        size="large"
        sx={{ px: 5, py: 1.5, borderRadius: 3 }}
        onClick={() => navigate("/new-login")}
      >
        Login
      </Button>
    </Container>
  );
};

export default Initial;
